import { defineTool } from '@/shell/tool';

/** Subjects (Flutter `/subjects`). */
export default defineTool({
  id: 'subjects',
  title: 'Subjects',
  summary: 'The subjects the courses teach.',
  section: 'learning-backend',
  order: 60,
  icon: 'bubble_chart',
  owner: '@Drabu',
  permission: 'subjects:use',
  routes: () => import('./SubjectsPage'),
});
